import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Select, Row, Col, FormInstance, Typography, Radio } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { CompaniesInfiniteSelectField, InputDate } from '@/components/_common';
import { InventoryFormValues } from '@/core/domain/inventory/inventories/Inventory.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import getInventoryReasons from '@/core/domain/inventory/inventories/getInventoriesReasons';
import moment from 'moment';

interface Props {
  form: FormInstance<InventoryFormValues>;
}

function InventoryForm({ form }: Props) {
  const intl = useIntl();
  const useDefaultEmptyField = useDefaultEmptyFieldError();

  const { Title } = Typography;

  return (
    <>
      <Form layout="vertical" form={form}>
        <Row gutter={[16, 9]}>
          <Col span={24} lg={12} md={12}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'inventory.form.modal.company',
              })}
              name={['company', 'id']}
              rules={[useDefaultEmptyField]}
            >
              <CompaniesInfiniteSelectField />
            </FloatingFormItem>
          </Col>

          <Col span={24} lg={12} md={12}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'inventory.form.modal.inventoryReason',
              })}
              name="reason"
              rules={[useDefaultEmptyField]}
            >
              <Select
                allowClear
                style={{ width: '100%' }}
                options={getInventoryReasons().map((reason) => ({
                  value: reason.value,
                  label: intl.formatMessage({ id: reason.labelId }),
                }))}
              ></Select>
            </FloatingFormItem>
          </Col>

          <Col lg={7} span={24} md={7}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'inventory.form.modal.date',
              })}
              name="date"
              rules={[useDefaultEmptyField]}
              initialValue={moment()}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24} lg={24}>
            <Title level={5}>
              {intl.formatMessage({
                id: 'inventory.form.modal.inventoryOf',
              })}
            </Title>

            <Form.Item initialValue="PART" name="productType">
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="PART">
                  <FormattedMessage id="inventory.form.modal.radio.part" />
                </Radio.Button>
                <Radio.Button value="CONSUMABLE">
                  <FormattedMessage id="inventory.form.modal.radio.consumables" />
                </Radio.Button>
                <Radio.Button value="ALL">
                  <FormattedMessage id="inventory.form.modal.radio.all" />
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default InventoryForm;
